import React from 'react';
import { useDemo } from '../../contexts/DemoContext';
interface SceneIllustrationProps {
  description: string;
  children: React.ReactNode;
  quietTitle?: string;
  className?: string;
}
export function SceneIllustration({
  description,
  children,
  quietTitle = 'Scene',
  className = ''
}: SceneIllustrationProps) {
  const {
    state
  } = useDemo();
  if (state.accessPreferences.quietView) {
    return <figure className={`rounded-2xl border border-line bg-sand px-5 py-4 ${className}`} data-id="element-29" data-mp="1c2a2ywjo826o">
        <figcaption data-id="element-30" data-mp="17aiecrk2s6j6">
          <span className="block text-sm font-bold text-teal" data-id="element-31" data-mp="179z5s1gbeuht">{quietTitle} · quiet view</span>
          <span className="mt-1 block text-ink" data-id="element-32" data-mp="12cz0hsrahvrr">{description}</span>
        </figcaption>
      </figure>;
  }
  return <figure className={`overflow-hidden rounded-2xl border border-line bg-paper hc-strong ${className}`} data-id="element-33" data-mp="ybwyj45zn5m3">
      {children}
      <figcaption className="border-t border-line px-4 py-2 text-sm text-ink/80" data-id="element-34" data-mp="tdc0nbe7ky0t">
        <span className="font-bold text-ink" data-id="element-35" data-mp="ocxz8c744mbr">Scene: </span>
        {description}
      </figcaption>
    </figure>;
}